import { useFormik } from 'formik';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import TableLoading from '../../../../core/common/loadingComponent/TableLoading';
import NoRecordFound from '../../../../core/common/noRecord/NoRecordFound';
import Ribbon from '../../../../core/common/ribbon/ribbon';
import TableHeading from '../../../../core/common/tableHeading/TableHeading';
import { useTableSelection } from '../../../../core/hooks/useTableSelection';
import { useGetjobScopeDetailsByIdQuery, useGetjobScopeHistoryQuery, useUpsertJobScopeMutation } from '../../../../services/EndPointsApis';
import { initialValuesJobScope } from '../../Projects/Accept Sale Wizard/InitialValuesJobScope';

const JobScopeWizard = ({ projectId, formik, showHistory, showRibbonJobScope, storeProjectId, setJobScopeData, setJobScopeInitialValues, jobScopeDetailsData }: any) => {
    const params = useParams()
    const [searchStr, setSearchStr] = useState('');
    const [sortBy, setSortBy] = useState("createDT");
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortedColumn, setSortedColumn] = useState("createDT");
    const [isRowClicked, setIsRowClicked] = useState(false)
    const [immediateSearchStr, setImmediateSearchStr] = useState('');

    //Upsert Api
    const [UpsertJobScope, { data, isError, error, isSuccess, isLoading }] = useUpsertJobScopeMutation();
    // const { data: jobScopeData, refetch, isLoading: isLoadingScope } = useGetjobScopeDetailsByIdQuery({ Id: projectId || storeProjectId });

    //Get history Api
    const { data: jobScopeHistory, refetch: refetchHistory, isLoading: isLoadingHistory } = useGetjobScopeHistoryQuery({ projectId: projectId, searchStr: searchStr || '', });
    //Get Api job scope
    const { data: jobScopeData, isLoading: isLoadingScope } = useGetjobScopeDetailsByIdQuery({ Id: projectId || storeProjectId });
    //Custom Table Hook 
    const {
        isTableHeadChecked,
        selectedIndividualCheckboxId,
        selectedItemData: UserData,
        handleTableHeadChange,
        handleCheckItem,
        handleRowClick,
        handleRowDoubleClick,
        handleDelete
    } = useTableSelection(jobScopeHistory?.result || [], 'userAccountId');

    //formik



    // const formik = useFormik({
    //     initialValues:initialValuesJobScope,
    //     onSubmit: (values) => {
    //         UpsertJobScope({ ...values })
    //     },

    // });


    useEffect(() => {
        if (jobScopeData?.result && Object.keys(jobScopeData?.result).length > 0) {
            formik?.setValues({ ...jobScopeData?.result });
            // setDisabledata(true)
        } else {
            // setUpdateId(0);
        }
    }, [jobScopeData]);

    useEffect(() => {
        if (setJobScopeData) {
            setJobScopeInitialValues(initialValuesJobScope)
            setJobScopeData(formik)
        }
    }, [setJobScopeData, formik?.values])

    useEffect(() => {
        if (jobScopeDetailsData && Object.keys(jobScopeDetailsData).length > 0) {
            formik?.setValues({ ...jobScopeDetailsData });
        }
    }, [jobScopeDetailsData]);


    const handleSort = (property: string) => {
        setSortBy(property);
        if (sortedColumn === property) {
            setSortOrder(prevSortOrder => (prevSortOrder === "asc" ? "desc" : "asc"));
        } else {
            setSortedColumn(property);
            setSortOrder("asc");
        }
        // Perform additional sorting logic...
    };

    const handleRowClicked = (data: any) => {
        handleRowClick(data);
        setIsRowClicked(true);
    }
    const handleSearchChange = (e: any) => {
        const { value } = e.target;
        setImmediateSearchStr(value);
        delayedSearch(value);
    };
    const delayedSearch = useCallback(
        debounce((searchValue) => {
            setSearchStr(searchValue);
        }, 500),
        []
    );

    useEffect(() => {
        if (searchStr === "" ||
            sortOrder === "" ||
            sortBy === "") {
            refetchHistory()
        }
    }, [searchStr, sortOrder, sortBy]);
    return (
        <>
            <div className='row'>
                <div className='col-md-12'>
                    {/* {!showRibbonJobScope &&
                        <Ribbon
                            // items={items}
                            buttonText={isLoading ? "Loading..." : "Save"}
                            onClickbtn={formik?.handleSubmit}
                            buttonClass="add-popup ribbon-btn"
                        />
                    } */}
                </div>
            </div>
            <div className='row'>
                <div className='col-md-12'>
                    <div className='row mt-3'>
                        <div className='col-md-12'>
                            <div className='card'>
                                <div className='card-body card-css'>
                                    <h5 className='mb-3'>Job Scope:</h5>
                                    <form onSubmit={formik?.handleSubmit}>
                                        <div className='d-flex gap-10 '>
                                            {/* First div */}
                                            <div className="first-div" style={{ width: '330px' }}>
                                                {formik?.values?.jobScopeResults?.filter((_: any, index: number) => index % 2 === 0).map((item: any, index: any) => {
                                                    const originalIndex = formik?.values?.jobScopeResults.findIndex((i: { surveyMasterId: any; }) => i.surveyMasterId === item.surveyMasterId);

                                                    return (
                                                        <div key={index} className='d-flex justify-content-between mb-2'>
                                                            <label className='mb-0'>{item?.name}</label>
                                                            {item?.name.includes('#') ? (
                                                                <input
                                                                    type='number'
                                                                    defaultValue={item?.surveyResultOriginal}
                                                                    style={{ width: '50px' }}
                                                                    {...formik.getFieldProps(`jobScopeResults[${originalIndex}].surveyResultOriginal`)}
                                                                    onChange={(e) => formik.setFieldValue(`jobScopeResults[${originalIndex}].surveyResultOriginal`, e.target.value.toString())}
                                                                />
                                                            ) : (
                                                                <label className="checkboxs mt-1">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={item?.surveyResultOriginal === '1'}
                                                                        onChange={() => {
                                                                            const newValue = item.surveyResultOriginal === '1' ? '0' : '1';
                                                                            formik.setFieldValue(`jobScopeResults[${originalIndex}].surveyResultOriginal`, newValue); // Ensure correct index
                                                                        }}
                                                                    />
                                                                    <span className="checkmarks" />
                                                                </label>
                                                            )}
                                                        </div>
                                                    );
                                                })}

                                            </div>
                                            {/* Second div */}
                                            <div className="second-div" style={{ width: '330px' }}>
                                                {formik?.values?.jobScopeResults?.filter((_: any, index: number) => index % 2 !== 0).map((item: any, index: any) => {
                                                    const originalIndex = formik?.values?.jobScopeResults.findIndex((i: { surveyMasterId: any; }) => i.surveyMasterId === item.surveyMasterId);

                                                    return (
                                                        <div key={index} className='d-flex justify-content-between mb-2'>
                                                            <label className='mb-0'>{item.name}</label>
                                                            {item.name.includes('#') ? (
                                                                <input
                                                                    type='number'
                                                                    defaultValue={item.surveyResultOriginal}
                                                                    style={{ width: '50px' }}
                                                                    // onChange={(e) => handleInputChange(item.surveyMasterId, e.target.value)}
                                                                    {...formik.getFieldProps(`jobScopeResults[${originalIndex}].surveyResultOriginal`)}
                                                                    onChange={(e) => formik.setFieldValue(`jobScopeResults[${originalIndex}].surveyResultOriginal`, e.target.value.toString())}
                                                                />
                                                            ) : (
                                                                <label className="checkboxs mt-1">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={item.surveyResultOriginal === '1'}
                                                                        onChange={() => {
                                                                            const newValue = item.surveyResultOriginal === '1' ? '0' : '1';
                                                                            formik.setFieldValue(`jobScopeResults[${originalIndex}].surveyResultOriginal`, newValue); // Ensure correct index
                                                                        }}
                                                                    />
                                                                    <span className="checkmarks" />
                                                                </label>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                        </div>
                        {/* <div className='col-md-2'></div> */}

                    </div>
                </div>
                <div className='col-md-12 d-flex justify-content-end '>
                    <div className='mt-2 bg-red text-redd position-fixed bottom-0 px-2 rounded' style={{ right: "0px" }}><i>Created at 11/17/2023 by Ann Marie.01:00:22 PM Last modified at 11/17/2023 01:00:22 PM by Maxx Klein.</i></div>
                </div>
            </div>
        </>
    )
}

export default JobScopeWizard